<div class="row">
	<div class="col-lg-6">
		<div class="panel flush">
			<div class="heading">Select assets to compare (ctrl-click for multiple)</div>
			<div class="content">
				@if (assets) {
				<div>
					<select class="form-control form-control-sm" [(ngModel)]="multiAsset" (ngModelChange)="updatedSelection()" multiple size="20">
						@for (asset of assets; track asset) {
						<option [ngValue]="asset">
							{{ asset.organization_name }} / {{ asset.fleet_name ? asset.fleet_name : "(No fleet)" }} / {{ asset.asset_name }}
							({{ asset.obcu_serial_number }})
						</option>
						}
					</select>
				</div>
				}
				@if (!assets) {
				<div>Loading...</div>
				}
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<div class="panel flush">
			<div class="heading">Select primary asset for config result</div>
			<div class="content">
				<p>The output XML will be based on the config XML from the primary asset</p>
				<select class="form-control form-control-sm mb-3" [(ngModel)]="primaryAsset" size="6">
					@for (asset of multiAsset; track asset) {
					<option [ngValue]="asset">
						{{ asset.organization_name }} / {{ asset.fleet_name ? asset.fleet_name : "(No fleet)" }} / {{ asset.asset_name }}
						({{ asset.obcu_serial_number }})
					</option>
					}
				</select>
				<app-action-button [action]="UpdateThresholds" [disabled]="!primaryAsset" [context]="this" processing="Generating...">Generate
					thresholds</app-action-button>
			</div>
		</div>
	</div>
</div>
@if (thresholdComponents !== null) {
<div class="panel">
	<div class="heading">Thresholding results</div>
	@if (thresholdComponents === undefined && !thresholdError) {
	<div class="content">Loading...</div>
	}
	@if (thresholdComponents === undefined && thresholdError) {
	<div class="content message-bad">{{thresholdError}}
	</div>
	}
	@if (thresholdComponents) {
	<div class="content">
		<div class="row">
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 col-form-label">Component:</label>
					<div class="col-md-9">
						<select class="form-control form-control-sm" [(ngModel)]="selectedComponent" (ngModelChange)="UpdateComponent($event)">
							@for (component of thresholdComponents; track component) {
							<option [ngValue]="component">
								{{component.description}}
								({{component.key}})</option>
							}
						</select>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Scale:</div>
					<div class="col-9">{{selectedComponent.thresholds.scale | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Offset:</div>
					<div class="col-9">{{selectedComponent.thresholds.offset | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Mean:</div>
					<div class="col-9">{{selectedComponent.thresholds.mean | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Warning:</div>
					<div class="col-9">{{selectedComponent.thresholds.warn | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Alarm:</div>
					<div class="col-9">{{selectedComponent.thresholds.alarm | roundlist : 4}}</div>
				</div>
			</div>
			<div class="col-md-6">
				<app-dvs-chart [options]="boxPlotOptions"></app-dvs-chart>
			</div>
		</div>
	</div>
	}
</div>
}
@if (newConfig) {
<div class="row">
	<div class="col-lg-6">
		<div class="panel flush constrain">
			<div class="heading">Updated asset configuration for {{queriedAssets[0].asset_name}}</div>
			<div class="content nopad">
				<textarea [(ngModel)]="newConfig" class="form-control flush" style="min-height: 400px;"></textarea>
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<p class="text-danger">Note: Updating the configuration will overwrite the existing configuration in the database!</p>
		<p>You are overwriting the config for:</p>
		<p class="text-white">{{queriedAssets[0].organization_name}} / {{queriedAssets[0].fleet_name ? queriedAssets[0].fleet_name : "(No fleet)"}} / {{queriedAssets[0].asset_name}}
			({{queriedAssets[0].obcu_serial_number}})</p>
		<app-action-button [action]="UploadConfig" [context]="this" processing="Updating..." complete="Config updated">
			Update Config</app-action-button>
	</div>
</div>
}